import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import PopupGnbMenuGroup from './PopupGnbMenuGroup';
import PopupGnbMenu from './PopupGnbMenu';
import GnbViewBox from './GnbViewBox';

export const InputGnbMenu = () => {
  const dispatch = useDispatch();
  const menuList = useSelector(state => state.menu.menuList);
  const [pageList, setPageList] = useState([]);

  const removePageList = count => {
    setPageList(pageList.filter(page => page.count !== count));
  };
  return (
    <>
      <div>
        {menuList?.length === 0 ? (
          <Button
            componentType="normal"
            label={i18n.t('BTY_W_T_ADD_MENU_DEFAULT')}
            className="add"
            iconInfo={{ className: 'ic-plus ', size: 'sm' }}
            tabIndex={0}
            onClick={() => {
              dispatch(wizardActions.openGnbPopup({ name: 'GNB' }));
            }}
          />
        ) : (
          menuList.map((item, idx) => {
            return <GnbViewBox item={item} key={idx} isGnb />;
          })
        )}
      </div>
      <PopupGnbMenuGroup pageList={pageList} removePageList={removePageList} setPageList={setPageList} />
      <PopupGnbMenu pageList={pageList} setPageList={setPageList} />
    </>
  );
};

InputGnbMenu.propTypes = {};
InputGnbMenu.defaultProps = {};
export default InputGnbMenu;
